import i18n from "lib/i18n"
import PropTypes from "prop-types"
import React from "react"

export default function Disclosure({ enabled }) {
  if (!enabled) {
    return <React.Fragment />
  }

  const disclosureHtml = { __html: i18n.t("recaptcha.disclosure_html") }

  return <div className="mt-5 text-xs" dangerouslySetInnerHTML={disclosureHtml} />
}

Disclosure.propTypes = {
  enabled: PropTypes.bool.isRequired,
}
